// Additional data for Charge Creation and Modification
export const chargeMonths = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const corporateStatuses = [
  { value: "", label: "All" },
  { value: "active", label: "Active" },
  { value: "active_compliance", label: "Active Compliant" },
  { value: "active_non_compliance", label: "Active Non-compliant" },
];

export const listingStatuses = [
  { value: "", label: "All" },
  { value: "listed", label: "Listed" },
  { value: "unlisted", label: "Unlisted" },
];

export const dataStatuses = [
  { value: "", label: "All" },
  { value: "1:1", label: "Probed" },
];

export const revenueRanges = [
  { value: "0-5", label: "Less than 5 crores", min: 0, max: 50000000 },
  { value: "5-50", label: "5 to 50 crores", min: 50000000, max: 500000000 },
  { value: "50-250", label: "50 to 250 crores", min: 500000000, max: 2500000000 },
  { value: "250-1000", label: "250 to 1000 crores", min: 2500000000, max: 10000000000 },
  { value: "1000+", label: "More than 1000 crores", min: 10000000000, max: Infinity },
];


export const creditRatings = [
  { value: "A", label: "A" },
  { value: "AA", label: "AA" },
  { value: "AAA", label: "AAA" },
  { value: "B", label: "B" },
  { value: "BB", label: "BB" },
  { value: "BBB", label: "BBB" },
  { value: "C", label: "C" },
  { value: "D", label: "D" },
];

export const classifications = [
  { value: "", label: "All Classifications" },
  { value: "PLC", label: "Public Limited Indian Non-Government Company" },
  { value: "PTC", label: "Private Limited Indian Non-Government Company" },
  { value: "OPC", label: "One Person Company" },
  {
    value: "FTC",
    label: "Private Limited Foreign Company Incorporated in India",
  },
  {
    value: "FLC",
    label: "Public Limited Foreign Company Incorporated in India",
  },
  { value: "GOI", label: "Union Government Company" },
  { value: "SGC", label: "State Government Company" },
  { value: "GAP", label: "Guarantee & Association Public" },
  { value: "GAT", label: "Guarantee & Association Private" },
  { value: "NPL", label: "Not For Profit Company" },
  { value: "ULL", label: "Unlimited Liabilities Public" },
  { value: "ULT", label: "Unlimited Liabilities Private" },
  { value: "PLN", label: "Nidhi Company" },
  { value: "LLP", label: "Limited Liability Partnership" },
];

export const industry = [
  { value: "", label: "All" },
  { value: "Agro", label: "Agro" },
  { value: "Airline", label: "Airline" },
  { value: "Apparel", label: "Apparel" },
  { value: "Automobiles", label: "Automobiles" },
  { value: "BFSI", label: "BFSI" },
  { value: "Biotechnology", label: "Biotechnology" },
  { value: "Business Services", label: "Business Services" },
  { value: "Chemicals", label: "Chemicals" },
  { value: "Cleantech", label: "Cleantech" },
  { value: "Consumer Durables", label: "Consumer Durables" },
  { value: "Consumer Products", label: "Consumer Products" },
  { value: "Consumer Services", label: "Consumer Services" },
  { value: "Defence", label: "Defence" },
  { value: "Education", label: "Education" },
  { value: "Engineering", label: "Engineering" },
  { value: "Events and Entertainment", label: "Events and Entertainment" },
  { value: "FMCG", label: "FMCG" },
  { value: "Food and Beverages", label: "Food and Beverages" },
  { value: "Healthcare", label: "Healthcare" },
  { value: "Information Technology", label: "Information Technology" },
  { value: "Infrastructure", label: "Infrastructure" },
  { value: "Internet", label: "Internet" },
  { value: "Machinery and Equipment", label: "Machinery and Equipment" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Media and Publishing", label: "Media and Publishing" },
  { value: "Metals and Minerals", label: "Metals and Minerals" },
  { value: "Oil and Gas", label: "Oil and Gas" },
  { value: "Outsourcing", label: "Outsourcing" },
  { value: "Packaging", label: "Packaging" },
  { value: "Pharma", label: "Pharma" },
  { value: "Power", label: "Power" },
  { value: "Real Estate", label: "Real Estate" },
  { value: "Shipping", label: "Shipping" },
  { value: "Telecom", label: "Telecom" },
  { value: "Transport and Logistics", label: "Transport and Logistics" },
  { value: "Unclassified Industry", label: "Unclassified Industry" },
  { value: "Utilities", label: "Utilities" },
];

export const segments = [
  { value: "", label: "All" },
  { value: "Accessories and Components", label: "Accessories and Components" },
  {
    value: "Accessories Retailers and Distributors",
    label: "Accessories Retailers and Distributors",
  },
  { value: "Account Aggregator", label: "Account Aggregator" },
  {
    value: "Accounting and Financial Analysis",
    label: "Accounting and Financial Analysis",
  },
  { value: "Advertising Companies", label: "Advertising Companies" },
  { value: "Aggregators", label: "Aggregators" },
  {
    value: "Agro Products Retailers and Distributors",
    label: "Agro Products Retailers and Distributors",
  },
  { value: "Air Cargo", label: "Air Cargo" },
  { value: "Air Passenger Services", label: "Air Passenger Services" },
  {
    value: "Aircraft and Aircraft Components Dealers",
    label: "Aircraft and Aircraft Components Dealers",
  },
  {
    value: "Aircrafts and Components Manufacturing",
    label: "Aircrafts and Components Manufacturing",
  },
  { value: "Airports", label: "Airports" },
  { value: "Alcoholic Beverages", label: "Alcoholic Beverages" },
  { value: "Alternative Medicine", label: "Alternative Medicine" },
  { value: "Animal Feeds", label: "Animal Feeds" },
  { value: "Animal Husbandry", label: "Animal Husbandry" },
  { value: "Animal Pharma", label: "Animal Pharma" },
  { value: "API Manufacturers", label: "API Manufacturers" },
  {
    value: "Apparel Retailers and Distributors",
    label: "Apparel Retailers and Distributors",
  },
  { value: "Apparels", label: "Apparels" },
  { value: "Application Developers", label: "Application Developers" },
  { value: "Aromatics", label: "Aromatics" },
  { value: "Asset Financing Companies", label: "Asset Financing Companies" },
  { value: "Asset Management", label: "Asset Management" },
  {
    value: "Asset Reconstruction Companies",
    label: "Asset Reconstruction Companies",
  },
  { value: "Auctions", label: "Auctions" },
  { value: "Auto", label: "Auto" },
  { value: "Auto Ancillary", label: "Auto Ancillary" },
  {
    value: "Auto and Auto Components Dealers",
    label: "Auto and Auto Components Dealers",
  },
  {
    value: "Ayurvedic Products and Services",
    label: "Ayurvedic Products and Services",
  },
  { value: "Baby Products", label: "Baby Products" },
  { value: "Banks", label: "Banks" },
  { value: "Beauty Salons and Spas", label: "Beauty Salons and Spas" },
  { value: "Biofuel and Biomass", label: "Biofuel and Biomass" },
  { value: "Biotechnology", label: "Biotechnology" },
  { value: "Bottles and Caps", label: "Bottles and Caps" },
  { value: "Branded Wear", label: "Branded Wear" },
  { value: "Broadbased Ecommerce", label: "Broadbased Ecommerce" },
  { value: "Broking Services", label: "Broking Services" },
  { value: "Builders and Developers", label: "Builders and Developers" },
  { value: "Bulk Cargo and Container", label: "Bulk Cargo and Container" },
  {
    value: "Business Auxiliary Services",
    label: "Business Auxiliary Services",
  },
  { value: "Cable Television and DTH", label: "Cable Television and DTH" },
  { value: "Cables and Wires", label: "Cables and Wires" },
  {
    value: "Call Taxi and Radio Cab Services",
    label: "Call Taxi and Radio Cab Services",
  },
  {
    value: "Carrying and Forwarding Agents",
    label: "Carrying and Forwarding Agents",
  },
  { value: "Cash Management", label: "Cash Management" },
  { value: "Casino and Gaming", label: "Casino and Gaming" },
  { value: "Casual Branded Wear", label: "Casual Branded Wear" },
  { value: "Catering", label: "Catering" },
  { value: "Celebrity Management", label: "Celebrity Management" },
  {
    value: "Cement and Products Manufacturers",
    label: "Cement and Products Manufacturers",
  },
  {
    value: "Ceramics, Sanitaryware and Tiles",
    label: "Ceramics, Sanitaryware and Tiles",
  },
  { value: "Charter Services", label: "Charter Services" },
  {
    value: "Chemical Retailers and Distributors",
    label: "Chemical Retailers and Distributors",
  },
  { value: "Cinema and Multiplex", label: "Cinema and Multiplex" },
  { value: "Classifieds", label: "Classifieds" },
  { value: "Cloud Computing", label: "Cloud Computing" },
  {
    value: "Cold Storage and Warehousing",
    label: "Cold Storage and Warehousing",
  },
  { value: "Colour Cosmetics", label: "Colour Cosmetics" },
  { value: "Commercial Printing", label: "Commercial Printing" },
  { value: "Commercial Vehicles", label: "Commercial Vehicles" },
  {
    value: "Components Retailers and Distributors",
    label: "Components Retailers and Distributors",
  },
  { value: "Compressors", label: "Compressors" },
  { value: "Computer Hardware", label: "Computer Hardware" },
  {
    value: "Confectionery and Bakery Products",
    label: "Confectionery and Bakery Products",
  },
  { value: "Construction Equipment", label: "Construction Equipment" },
  { value: "Construction Materials", label: "Construction Materials" },
  {
    value: "Construction Materials Retailers and Distributors",
    label: "Construction Materials Retailers and Distributors",
  },
  { value: "Consultancy Services", label: "Consultancy Services" },
  {
    value: "Consumer Review and Ratings",
    label: "Consumer Review and Ratings",
  },
  { value: "Content Providers", label: "Content Providers" },
  { value: "Contract Farming", label: "Contract Farming" },
  { value: "Contract Manufacturing", label: "Contract Manufacturing" },
  { value: "Contract Research", label: "Contract Research" },
  { value: "Control Valves", label: "Control Valves" },
  { value: "Core Investment Companies", label: "Core Investment Companies" },
  {
    value: "Corporate and Commercial Training",
    label: "Corporate and Commercial Training",
  },
  { value: "Cosmetics", label: "Cosmetics" },
  {
    value: "Credit Rating and Information Services",
    label: "Credit Rating and Information Services",
  },
  {
    value: "Crockery and Utensils Manufacturers",
    label: "Crockery and Utensils Manufacturers",
  },
  { value: "Customer Loyalty Solutions", label: "Customer Loyalty Solutions" },
  { value: "Customized Gifts", label: "Customized Gifts" },
  { value: "Cycles", label: "Cycles" },
  { value: "Database Management", label: "Database Management" },
  { value: "Day Care Centres", label: "Day Care Centres" },
  { value: "Denim Wear", label: "Denim Wear" },
  {
    value: "Diagnostic Centres and Pathology Laboratories",
    label: "Diagnostic Centres and Pathology Laboratories",
  },
  { value: "Die Castings", label: "Die Castings" },
  {
    value: "Distribution and Transmission",
    label: "Distribution and Transmission",
  },
  { value: "Diversified BPO", label: "Diversified BPO" },
  { value: "Diversified Logistics", label: "Diversified Logistics" },
  { value: "Dredging", label: "Dredging" },
  { value: "Dyes and Pigments", label: "Dyes and Pigments" },
  { value: "E-ticketing", label: "E-ticketing" },
  { value: "Edible oils", label: "Edible oils" },
  { value: "Education", label: "Education" },
  {
    value: "Education Equipment and Infrastructure Providers",
    label: "Education Equipment and Infrastructure Providers",
  },
  { value: "Education Technology", label: "Education Technology" },
  { value: "eLearning", label: "eLearning" },
  {
    value: "Electrical and Bio Fuel Vehicles",
    label: "Electrical and Bio Fuel Vehicles",
  },
  {
    value: "Electronic Appliances Manufacturer",
    label: "Electronic Appliances Manufacturer",
  },
  {
    value: "Electronic Appliances Retailers and Distributors",
    label: "Electronic Appliances Retailers and Distributors",
  },
  {
    value: "Electronic Equipment and Components Manufacturers",
    label: "Electronic Equipment and Components Manufacturers",
  },
  { value: "Electronic Goods", label: "Electronic Goods" },
  { value: "Energy Solutions", label: "Energy Solutions" },
  { value: "Engineering Design", label: "Engineering Design" },
  { value: "Entertainment", label: "Entertainment" },
  { value: "Entertainment Properties", label: "Entertainment Properties" },
  { value: "Enzymes", label: "Enzymes" },
  { value: "EPC", label: "EPC" },
  { value: "EPC, BoP and BTG", label: "EPC, BoP and BTG" },
  { value: "Equipment and Technology", label: "Equipment and Technology" },
  { value: "Equipment Manufacturers", label: "Equipment Manufacturers" },
  { value: "ERP", label: "ERP" },
  { value: "Ethnic Wear", label: "Ethnic Wear" },
  { value: "Events Management", label: "Events Management" },
  { value: "Exchange", label: "Exchange" },
  { value: "Exhibitions", label: "Exhibitions" },
  { value: "Exploration and Production", label: "Exploration and Production" },
  { value: "Express Logistics", label: "Express Logistics" },
  { value: "Eye Accessories", label: "Eye Accessories" },
  {
    value: "Facility Management Services",
    label: "Facility Management Services",
  },
  { value: "Farm Equipment", label: "Farm Equipment" },
  { value: "Farm Produce", label: "Farm Produce" },
  { value: "Fertilizers", label: "Fertilizers" },
  {
    value: "Film and Content Production",
    label: "Film and Content Production",
  },
  { value: "Films and Foils", label: "Films and Foils" },
  { value: "Finance", label: "Finance" },
  {
    value: "Financial Instrument Distributors",
    label: "Financial Instrument Distributors",
  },
  { value: "Fire Fighting Products", label: "Fire Fighting Products" },
  { value: "Fishing Industry", label: "Fishing Industry" },
  { value: "Fittings", label: "Fittings" },
  {
    value: "Flavouring and Seasoning Additives",
    label: "Flavouring and Seasoning Additives",
  },
  { value: "Floriculture", label: "Floriculture" },
  {
    value: "Food and Beverages Retailers and Distributors",
    label: "Food and Beverages Retailers and Distributors",
  },
  { value: "Food Testing", label: "Food Testing" },
  { value: "Footwear", label: "Footwear" },
  { value: "Footwear Manufacturers", label: "Footwear Manufacturers" },
  {
    value: "Footwear Retailers and Distributors",
    label: "Footwear Retailers and Distributors",
  },
  { value: "Formal Branded Wear", label: "Formal Branded Wear" },
  { value: "Formulations", label: "Formulations" },
  { value: "Foundry and Fabrication", label: "Foundry and Fabrication" },
  { value: "Four Wheelers", label: "Four Wheelers" },
  { value: "Fruits and Vegetables", label: "Fruits and Vegetables" },
  { value: "Furniture", label: "Furniture" },
  {
    value: "Furniture Retailers and Distributors",
    label: "Furniture Retailers and Distributors",
  },
  { value: "Gaming Portal", label: "Gaming Portal" },
  { value: "Gas", label: "Gas" },
  { value: "General Insurance", label: "General Insurance" },
  { value: "Geo Engineering", label: "Geo Engineering" },
  {
    value: "Geographic Information System",
    label: "Geographic Information System",
  },
  { value: "Glass Works", label: "Glass Works" },
  { value: "Gold NBFCs", label: "Gold NBFCs" },
  { value: "Graphite", label: "Graphite" },
  { value: "Grocery", label: "Grocery" },
  { value: "Ground Handling Services", label: "Ground Handling Services" },
  { value: "Group Buying", label: "Group Buying" },
  { value: "Guest Houses", label: "Guest Houses" },
  { value: "Gyms", label: "Gyms" },
  { value: "Hair Care", label: "Hair Care" },
  { value: "Handicrafts Manufacturers", label: "Handicrafts Manufacturers" },
  {
    value: "Health and Beauty Products Retailers and Distributors",
    label: "Health and Beauty Products Retailers and Distributors",
  },
  { value: "Health and Organic Foods", label: "Health and Organic Foods" },
  {
    value: "Healthcare Equipment Retailers and Distributors",
    label: "Healthcare Equipment Retailers and Distributors",
  },
  { value: "Healthcare Insurance", label: "Healthcare Insurance" },
  { value: "Healthcare Products", label: "Healthcare Products" },
  { value: "Healthcare Services", label: "Healthcare Services" },
  { value: "Healthcare Technology", label: "Healthcare Technology" },
  { value: "Heavy Engineering", label: "Heavy Engineering" },
  { value: "Holding Company", label: "Holding Company" },
  { value: "Home Care Products", label: "Home Care Products" },
  {
    value: "Home Furnishings and Accessories Retailers and Distributors",
    label: "Home Furnishings and Accessories Retailers and Distributors",
  },
  {
    value: "Home Furnishings Manufacturers",
    label: "Home Furnishings Manufacturers",
  },
  {
    value: "Hospital Infrastructure Providers",
    label: "Hospital Infrastructure Providers",
  },
  { value: "Hotels", label: "Hotels" },
  { value: "Housing Finance", label: "Housing Finance" },
  { value: "HR Outsourcing", label: "HR Outsourcing" },
  { value: "Hydraulic Equipment", label: "Hydraulic Equipment" },
  { value: "Hydro Power", label: "Hydro Power" },
  { value: "Hydroprojects", label: "Hydroprojects" },
  { value: "Hypermarkets", label: "Hypermarkets" },
  { value: "Industrial Chemicals", label: "Industrial Chemicals" },
  { value: "Industrial Gases", label: "Industrial Gases" },
  { value: "Industrial Packaging", label: "Industrial Packaging" },
  {
    value: "Industrial Products Manufacturers",
    label: "Industrial Products Manufacturers",
  },
  {
    value: "Industrial Products Retailers and Distributors",
    label: "Industrial Products Retailers and Distributors",
  },
  { value: "Information Providers", label: "Information Providers" },
  { value: "Infrastructure Debt Fund", label: "Infrastructure Debt Fund" },
  { value: "Infrastructure Finance", label: "Infrastructure Finance" },
  {
    value: "Infrastructure Finance Company",
    label: "Infrastructure Finance Company",
  },
  { value: "Infrastructure Management", label: "Infrastructure Management" },
  { value: "Infrastructure Services", label: "Infrastructure Services" },
  { value: "Inner Wear", label: "Inner Wear" },
  { value: "Instant Foods", label: "Instant Foods" },
  { value: "Insurance Broking Firms", label: "Insurance Broking Firms" },
  { value: "Investment Bankers", label: "Investment Bankers" },
  {
    value: "IT Consulting and Other Services",
    label: "IT Consulting and Other Services",
  },
  {
    value: "IT Products Retailers and Distributors",
    label: "IT Products Retailers and Distributors",
  },
  {
    value: "Jewellery and Gems Retailers and Distributors",
    label: "Jewellery and Gems Retailers and Distributors",
  },
  { value: "Jobs", label: "Jobs" },
  { value: "K12 and Higher Education", label: "K12 and Higher Education" },
  { value: "Kids Wear", label: "Kids Wear" },
  {
    value: "Landline, ISP and Broadband",
    label: "Landline, ISP and Broadband",
  },
  {
    value: "Leasing of Machinery and Equipment",
    label: "Leasing of Machinery and Equipment",
  },
  { value: "Leasing of Real Estate", label: "Leasing of Real Estate" },
  { value: "Leather", label: "Leather" },
  {
    value: "Leather Goods Manufacturers",
    label: "Leather Goods Manufacturers",
  },
  { value: "Legal Process Outsourcing", label: "Legal Process Outsourcing" },
  { value: "Life Insurance", label: "Life Insurance" },
  {
    value: "Lifestyle and Accessories Manufacturers",
    label: "Lifestyle and Accessories Manufacturers",
  },
  { value: "Machine Tools", label: "Machine Tools" },
  {
    value: "Machinery and Equipment Retailers and Distributors",
    label: "Machinery and Equipment Retailers and Distributors",
  },
  { value: "Maintenance Services", label: "Maintenance Services" },
  {
    value: "Maintenance, Repair and Overhaul",
    label: "Maintenance, Repair and Overhaul",
  },
  { value: "Mall Management", label: "Mall Management" },
  { value: "Marine Engineering", label: "Marine Engineering" },
  { value: "Marketing", label: "Marketing" },
  {
    value: "Material Handling Equipment",
    label: "Material Handling Equipment",
  },
  {
    value: "Materials Retailers and Distributors",
    label: "Materials Retailers and Distributors",
  },
  { value: "Matrimonial", label: "Matrimonial" },
  { value: "Meat and Fish Processing", label: "Meat and Fish Processing" },
  {
    value: "Medical and Laboratory Equipment",
    label: "Medical and Laboratory Equipment",
  },
  { value: "Medical Consumables", label: "Medical Consumables" },
  { value: "Medical Transcription", label: "Medical Transcription" },
  {
    value: "Metal Retailers and Distributors",
    label: "Metal Retailers and Distributors",
  },
  { value: "Metals", label: "Metals" },
  { value: "Micro Finance", label: "Micro Finance" },
  { value: "Micro Finance Institutions", label: "Micro Finance Institutions" },
  { value: "Milk and Dairy Products", label: "Milk and Dairy Products" },
  { value: "Mining", label: "Mining" },
  { value: "Mobile", label: "Mobile" },
  { value: "Mobile VAS", label: "Mobile VAS" },
  { value: "Money Exchangers", label: "Money Exchangers" },
  { value: "Multi Speciality Hospitals", label: "Multi Speciality Hospitals" },
  { value: "Music", label: "Music" },
  { value: "Musical Instruments", label: "Musical Instruments" },
  { value: "NBFC", label: "NBFC" },
  {
    value: "NBFC Accepting Public Deposits",
    label: "NBFC Accepting Public Deposits",
  },
  {
    value: "NBFC Asset Size of Rs 100 CR and Above",
    label: "NBFC Asset Size of Rs 100 CR and Above",
  },
  { value: "NBFC Factors", label: "NBFC Factors" },
  {
    value: "NBFC Investment and Credit Companies",
    label: "NBFC Investment and Credit Companies",
  },
  {
    value:
      "NBFC Non-Deposit taking Non-Systemically Important with assets more than Rs 100 CR",
    label:
      "NBFC Non-Deposit taking Non-Systemically Important with assets more than Rs 100 CR",
  },
  {
    value: "NBFC Non-Deposit taking Systemically Important",
    label: "NBFC Non-Deposit taking Systemically Important",
  },
  {
    value:
      "NBFC Not Accepting Public Deposits Other than Systemically Important",
    label:
      "NBFC Not Accepting Public Deposits Other than Systemically Important",
  },
  { value: "NBFC Peer-to-Peer Platform", label: "NBFC Peer-to-Peer Platform" },
  { value: "Network Support Services", label: "Network Support Services" },
  { value: "Non Alcoholic Beverages", label: "Non Alcoholic Beverages" },
  {
    value: "Non-Operative Financial Holding Company",
    label: "Non-Operative Financial Holding Company",
  },
  { value: "Nuclear Power Plants", label: "Nuclear Power Plants" },
  { value: "Office and School Supplies", label: "Office and School Supplies" },
  { value: "Online Service Providers", label: "Online Service Providers" },
  { value: "Organic Chemicals", label: "Organic Chemicals" },
  { value: "Other Agri Services", label: "Other Agri Services" },
  {
    value: "Other Construction Services",
    label: "Other Construction Services",
  },
  { value: "Other Financial Services", label: "Other Financial Services" },
  {
    value: "Other Infrastructure Services",
    label: "Other Infrastructure Services",
  },
  { value: "Other Metals and Minerals", label: "Other Metals and Minerals" },
  {
    value: "Other Transport Equipment Retailers and Distributors",
    label: "Other Transport Equipment Retailers and Distributors",
  },
  { value: "Packaging Machines", label: "Packaging Machines" },
  { value: "Packers and Movers", label: "Packers and Movers" },
  { value: "Paint", label: "Paint" },
  { value: "Paper", label: "Paper" },
  {
    value: "Paper and Laminated and Corrugated",
    label: "Paper and Laminated and Corrugated",
  },
  { value: "Parking", label: "Parking" },
  {
    value: "Passenger Transport Services",
    label: "Passenger Transport Services",
  },
  { value: "Payment Gateways", label: "Payment Gateways" },
  { value: "Payment Solution Providers", label: "Payment Solution Providers" },
  { value: "Perfume", label: "Perfume" },
  {
    value: "Personal Care and Skin Care",
    label: "Personal Care and Skin Care",
  },
  { value: "Pesticides", label: "Pesticides" },
  { value: "Pet Foods", label: "Pet Foods" },
  { value: "Petrochemicals", label: "Petrochemicals" },
  { value: "Pharma Packaging", label: "Pharma Packaging" },
  {
    value: "Pharma Retailers and Distributors",
    label: "Pharma Retailers and Distributors",
  },
  { value: "Pipes", label: "Pipes" },
  { value: "Plastic based Products", label: "Plastic based Products" },
  { value: "Plastics and Resins", label: "Plastics and Resins" },
  { value: "Portfolio Managers", label: "Portfolio Managers" },
  { value: "Ports", label: "Ports" },
  { value: "Poultry Industry", label: "Poultry Industry" },
  { value: "Power", label: "Power" },
  { value: "Power Cables", label: "Power Cables" },
  { value: "Power Projects", label: "Power Projects" },
  { value: "Power Trading", label: "Power Trading" },
  { value: "Prepaid and Cashcards", label: "Prepaid and Cashcards" },
  { value: "Preschools", label: "Preschools" },
  {
    value: "Preventive Healthcare Services",
    label: "Preventive Healthcare Services",
  },
  {
    value: "Preventive Healthcare Supplements",
    label: "Preventive Healthcare Supplements",
  },
  { value: "Print Media", label: "Print Media" },
  { value: "Private Bus Operators", label: "Private Bus Operators" },
  { value: "Process Machinery", label: "Process Machinery" },
  { value: "Products and Technology", label: "Products and Technology" },
  { value: "Professional Networking", label: "Professional Networking" },
  { value: "Professional Services", label: "Professional Services" },
  { value: "Project Management", label: "Project Management" },
  { value: "Publishing", label: "Publishing" },
  {
    value: "Publishing and Other Media Distributors",
    label: "Publishing and Other Media Distributors",
  },
  { value: "Pumps", label: "Pumps" },
  { value: "Radioactive Material", label: "Radioactive Material" },
  { value: "Rail Freight Services", label: "Rail Freight Services" },
  {
    value: "Railway Equipment and Products",
    label: "Railway Equipment and Products",
  },
  { value: "Railwork", label: "Railwork" },
  { value: "Real Estate Broking Firms", label: "Real Estate Broking Firms" },
  { value: "Real Estate Marketing", label: "Real Estate Marketing" },
  { value: "Real Estate Services", label: "Real Estate Services" },
  {
    value: "Recycling and Waste Treatment",
    label: "Recycling and Waste Treatment",
  },
  { value: "Rentals", label: "Rentals" },
  { value: "Restaurants", label: "Restaurants" },
  { value: "Reverse Logistics", label: "Reverse Logistics" },
  { value: "Road Carriers and Trucking", label: "Road Carriers and Trucking" },
  { value: "Roads and Bridges", label: "Roads and Bridges" },
  { value: "Robotics", label: "Robotics" },
  { value: "Rubber", label: "Rubber" },
  { value: "Rubber based Products", label: "Rubber based Products" },
  { value: "SaaS Providers", label: "SaaS Providers" },
  { value: "Search Engine", label: "Search Engine" },
  { value: "Security Products", label: "Security Products" },
  { value: "Security Services", label: "Security Services" },
  { value: "Seeds", label: "Seeds" },
  {
    value: "Semiconductor Manufacturing",
    label: "Semiconductor Manufacturing",
  },
  {
    value: "Semiconductor Products and Services",
    label: "Semiconductor Products and Services",
  },
  { value: "Service Apartments", label: "Service Apartments" },
  { value: "Service Contractors", label: "Service Contractors" },
  { value: "Service Providers", label: "Service Providers" },
  {
    value: "Ship Broking and Shipping Agency",
    label: "Ship Broking and Shipping Agency",
  },
  { value: "Ship Building and Repairs", label: "Ship Building and Repairs" },
  { value: "Shipping Services", label: "Shipping Services" },
  {
    value: "Single Specialty-Cardiology",
    label: "Single Specialty-Cardiology",
  },
  {
    value: "Single Specialty-Cosmetic Surgery",
    label: "Single Specialty-Cosmetic Surgery",
  },
  {
    value: "Single Specialty-Dental Care",
    label: "Single Specialty-Dental Care",
  },
  {
    value: "Single Specialty-Diabetic Care",
    label: "Single Specialty-Diabetic Care",
  },
  { value: "Single Specialty-Eye Care", label: "Single Specialty-Eye Care" },
  {
    value: "Single Specialty-Hearing and Speech Therapy",
    label: "Single Specialty-Hearing and Speech Therapy",
  },
  {
    value: "Single Specialty-IVF Centres and Maternity",
    label: "Single Specialty-IVF Centres and Maternity",
  },
  { value: "Single Specialty-Oncology", label: "Single Specialty-Oncology" },
  {
    value: "Single Specialty-Orthopedic",
    label: "Single Specialty-Orthopedic",
  },
  {
    value: "Single Specialty-Renal Care",
    label: "Single Specialty-Renal Care",
  },
  {
    value: "Single Specialty-Veterinary Hospitals",
    label: "Single Specialty-Veterinary Hospitals",
  },
  { value: "Soaps and Detergents", label: "Soaps and Detergents" },
  { value: "Social Networking", label: "Social Networking" },
  { value: "Software Services", label: "Software Services" },
  { value: "Solar Power", label: "Solar Power" },
  { value: "Solvent Extraction", label: "Solvent Extraction" },
  { value: "Speciality Chemicals", label: "Speciality Chemicals" },
  { value: "Spices", label: "Spices" },
  { value: "Sports", label: "Sports" },
  {
    value: "Sports Equipment Manufacturers",
    label: "Sports Equipment Manufacturers",
  },
  {
    value: "Sports Equipment Retailers and Distributors",
    label: "Sports Equipment Retailers and Distributors",
  },
  { value: "Sports Merchandise", label: "Sports Merchandise" },
  { value: "Staple Food", label: "Staple Food" },
  { value: "Steel", label: "Steel" },
  { value: "Streaming Media", label: "Streaming Media" },
  { value: "Student Networking", label: "Student Networking" },
  { value: "Sugar", label: "Sugar" },
  { value: "Supply Chain Processes", label: "Supply Chain Processes" },
  { value: "Surfactants", label: "Surfactants" },
  { value: "Tea and Coffee", label: "Tea and Coffee" },
  { value: "Telecom Infrastructure", label: "Telecom Infrastructure" },
  { value: "Telemedicine", label: "Telemedicine" },
  { value: "Test Preparation", label: "Test Preparation" },
  { value: "Testing Equipment", label: "Testing Equipment" },
  { value: "Textile", label: "Textile" },
  {
    value: "Textile Retailers and Distributors",
    label: "Textile Retailers and Distributors",
  },
  { value: "Thermal Power Plants", label: "Thermal Power Plants" },
  { value: "Third Party Administrators", label: "Third Party Administrators" },
  { value: "Third Party Logistics", label: "Third Party Logistics" },
  { value: "Time Shares", label: "Time Shares" },
  {
    value: "Tobacco and Tobacco Products",
    label: "Tobacco and Tobacco Products",
  },
  { value: "Tools and Components", label: "Tools and Components" },
  { value: "Tour and Travel Operators", label: "Tour and Travel Operators" },
  { value: "Toys Manufacturers", label: "Toys Manufacturers" },
  { value: "Tractors", label: "Tractors" },
  {
    value: "Transmission and Distribution",
    label: "Transmission and Distribution",
  },
  { value: "Tunnel Engineering", label: "Tunnel Engineering" },
  { value: "TV and Radio Broadcasting", label: "TV and Radio Broadcasting" },
  { value: "Two and Three Wheelers", label: "Two and Three Wheelers" },
  { value: "Unclassified Segment", label: "Unclassified Segment" },
  { value: "Uniform and Work Wear", label: "Uniform and Work Wear" },
  { value: "Vehicles", label: "Vehicles" },
  { value: "Vocational Training", label: "Vocational Training" },
  { value: "Watches and Jewellery", label: "Watches and Jewellery" },
  {
    value: "Watches and Jewellery Manufacturers",
    label: "Watches and Jewellery Manufacturers",
  },
  { value: "Water", label: "Water" },
  {
    value: "Water and Waste Water Treatment",
    label: "Water and Waste Water Treatment",
  },
  {
    value: "Website Design and Maintenance",
    label: "Website Design and Maintenance",
  },
  {
    value: "Wellness Healthcare Centres",
    label: "Wellness Healthcare Centres",
  },
  { value: "White Goods", label: "White Goods" },
  { value: "Wind Power", label: "Wind Power" },
  { value: "Winter Wear", label: "Winter Wear" },
  {
    value: "Wood, MDF, Particle Board and Plywood",
    label: "Wood, MDF, Particle Board and Plywood",
  },
  { value: "Woven Products", label: "Woven Products" },
];
